import React from 'react'

export const HiddenField = ({ blok }) => (
  <input type="text" name={blok.name} defaultValue={blok.default_value} className="d-none" />
)
  
